import { connect } from 'react-redux'
import { compose } from 'redux'
import { printDataUpdateRequest, updateFlyerSettings } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { FLYER_DATA } from '../../../constants/state'
import EditFlyer from '../present/EditFlyer'

const mapStateToProps = (state, ownProps) => ({
    flyerServerData: getData(state, FLYER_DATA)
})

const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: (itemData) => {
        dispatch(updateFlyerSettings(itemData.flyerSettings, itemData.pk))
        dispatch(printDataUpdateRequest())
    }
})

const EditFlyerContainer = ({flyerServerData, onUpdateItem, closePagePath, itemId}) => {
    let itemData

    if(!flyerServerData) {
        return ''
    }

    itemData = flyerServerData.flyers && flyerServerData.flyers[itemId]

    if(!itemData) {
        return ''
    }

    return <EditFlyer
        itemData={itemData}
        closePagePath={closePagePath}
        onUpdateItem={onUpdateItem}
    />
}

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditFlyerContainer)